import { css } from '@emotion/css';

export const segmentStyles = css`
  min-width: 150px;
`;
